<app-smart-alert-template name="alerts.smart_alerts.smart_budget.title"
                          description="alerts.smart_alerts.smart_budget.subtitle"
                          [notification]="notification$ | async"
                          [channels]="channels$  | async"></app-smart-alert-template>
